// Import worker as raw text so Vite bundles it inline — no network fetch at runtime.
// This prevents service worker interception (PWA) and worker-fetch failures (Capacitor WebView).
import workerRaw from 'pdfjs-dist/build/pdf.worker.min.mjs?raw';

let cachedBlobUrl: string | null = null;

export function getPdfWorkerBlobUrl(): string {
  if (!cachedBlobUrl) {
    const blob = new Blob([workerRaw], { type: 'application/javascript' });
    cachedBlobUrl = URL.createObjectURL(blob);
  }
  return cachedBlobUrl;
}
